// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"358":"3a9dac48","372":"e77a8d64","562":"ad180523","630":"fe670a88","702":"f6045721","768":"9f79ce31","788":"47abb6ed","882":"c470b6af","977":"2db71342","991":"24cba8f4"}[chunkId] + ".chunk.js";
};